module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th', [_vm._v("\n                E-mail\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'email',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n                Status\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'status',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1), _vm._v(" "), _c('th', [_vm._v("\n                Zaimportowany\n                "), _c('sorting', {
    attrs: {
      "sort": _vm.meta.sort,
      "key-for": 'was_imported',
      "direction": _vm.meta.direction
    },
    on: {
      "change-order": _vm.changeOrder
    }
  })], 1)]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [_vm._v("\n                " + _vm._s(item.email) + "\n            ")]), _vm._v(" "), _c('td', [(item) ? _c('email-status', {
      attrs: {
        "item": item
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('td', [(item.was_imported) ? _c('p', [_vm._v("\n                    Tak. " + _vm._s(item.imported_at_formated) + "\n                ")]) : _vm._e(), _vm._v(" "), (!item.was_imported) ? _c('p', [_vm._v("\n                    Nie\n                ")]) : _vm._e()])])
  })], 2), _vm._v(" "), _c('basic-pagination', {
    attrs: {
      "meta": _vm.meta
    },
    on: {
      "pagination-page": _vm.changePage,
      "pagination-limit": _vm.changeLimit
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11adbd78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/messages/SendToList.vue
// module id = 227
// module chunks = 0